import { state as stateApp } from '../app.logic'
import moment from 'moment'

export const dateFormat = ({ text, format }) => {
    if (!text) {
        return null;
    }
    let result = moment(text);
    if (stateApp.locale === "th") {
        result = result.add(543, "years");
    }
    return result.format(format);
}

/* export const dateFormat = ({ dateStr, format, offsetYear = 0 }) => {
    if (!dateStr) {
        return null;
    }
    const m = moment(dateStr);
    const yyyy = parseInt(m.format("YYYY")) + offsetYear;
    return m.format(format.replace("YYYY", yyyy).replace("YY", yyyy.toString().substring(2, 4)));
}; */